import en from './en.json';
import es from './es.json';

const LOCALES = {
  en,
  es,
};

export default LOCALES;
